var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_orange",
    d: "M41.71 35.85L22.94 3.96c-.62-1.05-1.99-1.4-3.05-.8-.34.19-.62.47-.81.8L.3 35.85c-.62 1.05-.25 2.39.81 3 .33.19.73.29 1.12.29h37.55c1.23 0 2.22-.98 2.22-2.19 0-.39-.1-.76-.29-1.1zm-18.69-1.83c-.56.55-1.35.9-2.21.9-1.73 0-3.13-1.37-3.13-3.07s1.4-3.08 3.13-3.08 3.14 1.38 3.14 3.08c0 .85-.34 1.62-.93 2.18zm.93-9.29c0 .69-.57 1.25-1.28 1.25h-3.71c-.71 0-1.28-.55-1.28-1.25V13.68c0-.69.57-1.25 1.28-1.25h3.7c.71 0 1.28.55 1.29 1.25v11.05z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_orange_compl",
    d: "M23.95 31.84c0 .85-.34 1.62-.93 2.18-.56.55-1.35.9-2.21.9-1.73 0-3.13-1.37-3.13-3.07s1.4-3.08 3.13-3.08 3.14 1.38 3.14 3.08zM23.95 13.69v11.05c0 .69-.57 1.25-1.28 1.25h-3.71c-.71 0-1.28-.55-1.28-1.25V13.69c0-.69.57-1.25 1.28-1.25h3.7c.71 0 1.28.55 1.29 1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2f96c0553066cd56a1eb87f93ba16cac.svg";
export { ForwardRef as ReactComponent };